module.exports = __webpack_public_path__ + "static/media/ggle-logo.f06b9089.png";